export default {
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: (resolve) => require(['@/views/Home'], resolve)
  },
  {
    path: '/login',
    name: 'Login',
    component: (resolve) => require(['@/views/Login'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/resetpassword/:token?',
    name: 'ResetPassword',
    component: (resolve) => require(['@/views/ResetPassword.vue'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/request-access',
    name: 'RequestAccessForm',
    component: (resolve) => require(['@/views/RequestAccessForm'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
    /**
     * User endpoints
     */
  {
    path: '/user',
    name: 'User',
    component: (resolve) => require(['@/views/user/UserList'], resolve)
  },
  {
    path: '/user/add',
    name: 'User.Add',
    component: (resolve) => require(['@/views/user/UserUpsert'], resolve)
  },
  {
    path: '/user/edit/:id',
    name: 'User.Edit',
    component: (resolve) => require(['@/views/user/UserUpsert'], resolve)
  },
    /**
     * Video endpoints
     */
  {
    path: '/video',
    name: 'Video',
    component: (resolve) => require(['@/views/video/VideoList'], resolve)
  },
  {
    path: '/video/add',
    name: 'Video.Add',
    component: (resolve) => require(['@/views/video/VideoUpsert'], resolve)
  },
  {
    path: '/video/edit/:id',
    name: 'Video.Edit',
    component: (resolve) => require(['@/views/video/VideoUpsert'], resolve)
  },

    /**
     * Location endpoints
     */
  {
    path: '/location',
    name: 'Location',
    component: (resolve) => require(['@/views/location/LocationList'], resolve)
  },
  {
    path: '/location/add',
    name: 'Location.Add',
    component: (resolve) => require(['@/views/location/LocationUpsert'], resolve)
  },
  {
    path: '/location/edit/:id',
    name: 'Location.Edit',
    component: (resolve) => require(['@/views/location/LocationUpsert'], resolve)
  },
  {
    path: '/location/reports',
    name: 'Location.Reports',
    component: (resolve) => require(['@/views/location/LocationReport'], resolve)
  },

  {
    path: '/category',
    name: 'Category.Edit',
    component: (resolve) => require(['@/views/category/CategoryUpsert'], resolve)
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: (resolve) => require(['@/views/error-pages/403'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
    /**
     * Not found
     */
  {
    path: '*',
    name: 'NotFound',
    component: (resolve) => require(['@/views/error-pages/404'], resolve),
    meta: {
      allowAnonymous: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes.js